export default __webpack_public_path__ + "i18n/hu.c97ba522f24ebd17ec7d58f82dcec7f3.json";